import interceptor from 'rest/interceptor';
import SessionStore from '../../../stores/SessionStore';
export default interceptor({
    response(response) {
        const { headers } = response;
        if (headers && headers.Authorization) {
            const [grantType, token] = headers.Authorization.split(' ');
            if (grantType === 'Bearer') {
                SessionStore.setAuthToken(token);
            }
        }
        return response;
    },
});
